var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 8,
    ry: 0,
    style: {
      fill: "#000",
      strokeWidth: 11.8582,
      strokeMiterlimit: 4.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "LOG IN",
    style: {
      fontSize: "5.33333px",
      lineHeight: 1.25,
      letterSpacing: 0,
      wordSpacing: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15 5.837q-.4 0-.667-.064-.266-.07-.426-.213-.16-.15-.23-.384-.064-.24-.064-.587V2.2h.806v2.358q0 .16.026.272.032.107.107.181.075.07.197.102.128.032.32.032h2.16v.693zM12.107 5.837q-.4 0-.666-.064-.267-.07-.427-.213-.16-.15-.23-.384-.063-.24-.063-.587V3.448q0-.342.064-.582.07-.24.23-.384.16-.149.426-.213.266-.07.666-.07h1.382q.405 0 .672.07.266.064.426.213.16.144.224.384.07.24.07.582v1.141q0 .347-.07.587-.064.234-.224.384-.16.144-.426.213-.267.064-.672.064zm1.963-2.352q0-.17-.032-.283-.027-.112-.096-.18-.07-.07-.192-.097-.117-.027-.293-.027h-1.312q-.192 0-.315.027-.117.027-.187.096-.069.07-.096.181-.02.112-.02.283v1.072q0 .176.02.293.027.112.096.182.07.064.187.09.123.022.315.022h1.312q.176 0 .293-.022.123-.026.192-.09.07-.07.096-.182.032-.117.032-.293zM16.843 5.837q-.4 0-.666-.064-.267-.07-.427-.213-.16-.15-.23-.384-.063-.24-.063-.587V3.448q0-.342.064-.582.07-.24.23-.384.16-.149.426-.213.266-.07.666-.07h.95v.7h-.912q-.182 0-.304.031-.118.027-.187.096-.07.07-.101.182-.027.112-.027.277v1.072q0 .181.027.299.032.112.101.176.075.064.192.09.123.022.299.022h1.37q.171 0 .288-.022.118-.026.187-.09.075-.07.107-.192.032-.123.032-.315v-.843h.81v.907q0 .347-.069.587-.064.234-.224.384-.16.144-.432.213-.267.064-.672.064zM22.363 5.837V2.2h.811v3.637zM27.654 5.917q-.128 0-.24-.043-.107-.037-.203-.128l-2.65-2.496v2.587h-.752V2.456q0-.17.117-.25.123-.086.315-.086.138 0 .23.037.09.037.148.096l2.672 2.576V2.2h.768v3.382q0 .181-.112.256-.112.08-.293.08z",
    style: {
      fontFamily: "Neuropolitical",
      InkscapeFontSpecification: "Neuropolitical",
      fill: "#ff0"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 5.185,
    y: -0.026,
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "13.33333333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.6dd612568e66c99d25da42665ea9d9d4.svg";
export { ForwardRef as ReactComponent };